import { createSelector } from 'reselect';

const selectValetData = (state) => state.valetData;

export const selectFlightIds = createSelector(
  [selectValetData],
  (valetData) => valetData.flightIds
);

export const selectFlightTimes = createSelector(
  [selectValetData],
  (valetData) => valetData.flightTimes
);

export const selectFlightIdsLoading = createSelector(
  [selectValetData],
  (valetData) => valetData.flightIdsLoading
);

export const selectSelectedFlightIds = createSelector(
  [selectValetData],
  (valetData) => valetData.selectedFlightIds
);

export const selectDof = createSelector(
  [selectValetData],
  (valetData) => valetData.dof
);

export const selectFlightCustomerData = createSelector(
  [selectValetData],
  (valetData) => valetData.flightCustomerData
);

export const selectCustomerDataLoading = createSelector(
  [selectValetData],
  (valetData) => valetData.customerDataLoading
);

export const selectCustomerCount = createSelector(
  [selectValetData],
  (valetData) => valetData.customerCount
);

export const selectFilteredFlightIds = createSelector(
  [selectValetData],
  (valetData) => valetData.filteredFlightIds
);

export const selectFilterTimeStart = createSelector(
  [selectValetData],
  (valetData) => valetData.filter.time.start
);

export const selectFilterTimeEnd = createSelector(
  [selectValetData],
  (valetData) => valetData.filter.time.end
);
export const selectDestination = createSelector(
  [selectValetData],
  (valetData) => valetData.destination
);